export default "__VITE_ASSET__yIM4L4QQ__"